import React, { useState } from 'react'
import { useDispatch } from 'dva'
import { Modal, Spin, message } from 'antd'
import { useHistory } from 'react-router-dom'
import AddCartContent from './AddCartContent'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/store'
import styles from './index.module.less'
import classNames from 'classnames'

const priceText = (min, max) => {
  if (!min && !max) return '0.00'
  if (min < max) return `${min?.toFixed(2)}~${max?.toFixed(2)}`
  if (min === max) return min?.toFixed(2)

  return min?.toFixed(2) || max?.toFixed(2)
}

interface ProductCardProps {
  data?: SwaggerDTO.商城首页列表商品
  className?: string
}

export default function ProductCard({ data, className }: ProductCardProps) {
  const dispatch = useDispatch()
  const history = useHistory()
  const [open, setOpen] = useState(false)

  /**购物车管理-添加购物车 */
  const { run: shopCartAddUsingPOST, loading } = useRequest(
    async params => {
      await api.shopCartAddUsingPOST(params)
      dispatch({ type: 'cart/getShopCartNum' })
      message.success('已加入购物车')
      setOpen(false)
    },
    { manual: true }
  )

  /**添加购物车-App */
  const {
    run: addCart,
    data: detail,
    loading: detailLoading,
  } = useRequest(
    async () => {
      // 商城商品详情查询
      const { data: detailData } = await api.queryDetailQueryUsingPOST({
        spuCode: data?.spuCode!,
      })
      // 文创
      if (data?.spuType === 3 && detailData?.skus?.length > 1) {
        setOpen(true)
        // 图书
      } else {
        const { skuCode, salePrice, standardPrice } =
          detailData?.skus?.[0] || {}

        shopCartAddUsingPOST({
          num: 1,
          price: standardPrice,
          productType: data?.spuType,
          salePrice,
          skuCode,
          spuCode: data?.spuCode,
        })
      }
      return detailData
    },
    { manual: true }
  )

  const openDetail = () => {
    // 文创
    if (data?.spuType === 3) {
      history.push(`/detail/booart?spuCode=${data?.spuCode}`)
    }

    // 图书
    if ([1, 4].includes(data?.spuType!)) {
      history.push(`/detail/book?spuCode=${data?.spuCode}`)
    }
  }

  return (
    <Spin spinning={loading || detailLoading}>
      <div
        className={classNames(styles.productCard, className)}
        onClick={openDetail}
      >
        <div className={styles.img}>
          <img
            src={data?.appImgUrl || require('app/assets/images/default.png')}
            alt=""
          />
        </div>
        <div className={styles.info}>
          <p className={styles.text} title="1111">
            {data?.spuName}
          </p>
          <div className={styles.price}>
            <span className={styles.priceText}>
              ¥ {priceText(data?.minSalePrice, data?.maxSalePrice)}
            </span>
            <img
              src={require('app/assets/images/shopping.png')}
              alt=""
              onClick={e => {
                addCart()
                e.stopPropagation()
              }}
            />
          </div>
        </div>
      </div>
      <Modal
        width={600}
        open={open}
        destroyOnClose
        keyboard={false}
        maskClosable={false}
        footer={false}
        onCancel={() => setOpen(false)}
      >
        <AddCartContent
          data={data}
          detailData={detail}
          onOk={shopCartAddUsingPOST}
        />
      </Modal>
    </Spin>
  )
}
